export default "__VITE_ASSET__DxH0HtOs__"